import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "news" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "text" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "btn" }

import {apiUrl} from '@/assets/js/global'
import {ArrowRightOutlined} from '@ant-design/icons-vue'
import rooter from '@/router'

export default /*@__PURE__*/_defineComponent({
  __name: 'news',
  props: {
    news:<any> {
        type: Array,
        default: () => []
    }
},
  setup(__props) {

const props = __props
const navigatorDetails = (id:any) => {
    rooter.push({
        path: '/newsDetails',
        query: {
            id: id
        } 
    })
}

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, { justify: "left" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { span: 2 }),
      _createVNode(_component_a_col, { span: 22 }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.news, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                onClick: ($event: any) => (navigatorDetails(item.id))
              }, [
                _createElementVNode("p", null, _toDisplayString(item.day), 1),
                _createElementVNode("p", null, _toDisplayString(item.time), 1),
                _createElementVNode("div", _hoisted_3, _toDisplayString(item.title), 1),
                _cache[0] || (_cache[0] = _createElementVNode("hr", null, null, -1)),
                _createElementVNode("img", {
                  src: _unref(apiUrl)+'/images/'+item.url
                }, null, 8, _hoisted_4),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_unref(ArrowRightOutlined))
                ])
              ], 8, _hoisted_2))
            }), 256))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})